<template>
  <ChartNormal
    size="12"
    offset="0"
    title="Projects"
    chart="column"
    chartType="projects"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
  />
</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "Projects",
  components: {
    ChartNormal
  }
};
</script>